var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgSlashMenu = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74.563,
    height: 110.479,
    viewBox: "0 0 74.563 110.479",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_860",
    "data-name": "Path 860",
    d: "M636.6,110.479,697.643,0h13.52L650.12,110.479Z",
    transform: "translate(-636.6)",
    fill: "#fff"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSlashMenu, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/slashMenu.b9a6b72e.svg";
export { ForwardRef as ReactComponent };